import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const NO_PAYWALL = ["/team", "/billing"];

export default function ProtectedRoute({ children, role = "player", paywall = true }) {
  const { user, loading, billing } = useAuth();
  const { pathname } = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to={window.__ppLoggingOut ? "/" : `/auth?mode=login&role=${role}`} replace />;
  const userRole = user.role || "player";
  if (role && userRole !== role) return <Navigate to={userRole === "club" ? "/club" : "/dashboard"} replace />;
  if (paywall && !NO_PAYWALL.includes(pathname)) {
    if (billing === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
    if (!billing.active) return <Navigate to="/pricing" replace />;
  }
  return children;
}
